const scrollTo = (el, pos, duration) => {
    if (duration <= 0) return;
    const difference = pos - el.scrollTop;
    const perTick = difference / duration * 10; // eslint-disable-line no-mixed-operators
    const element = el;

    setTimeout(() => {
        element.scrollTop += perTick;
        if (element.scrollTop === pos) return;
        scrollTo(element, pos, duration - 10);
    }, 10);
};

export default scrollTo;
